"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Deutsche Lokalisierung
 */
exports.default = {
    /**
     * Willkommensseite
     */
    skip: 'Überspringen',
    letsStart: "Los geht's",
    next: 'Weiter',
    registerNow: 'Jetzt registrieren',
    welcome_title_1: 'Entdecke die erste Wallet auf Basis von NFTs',
    welcome_subtitle_1: 'Kaufen, sammeln und handeln von Gegenständen',
    welcome_title_2: 'Erstelle jetzt deine eigene NFT-Sammlung',
    welcome_subtitle_2: 'Kaufen, sammeln und handeln von Gegenständen',
    welcome_title_3: 'Entdecke die aufregende Welt der Kryptowährung',
    welcome_subtitle_3: 'Kaufen, sammeln und handeln von Gegenständen',
    /**
     * Login- und Registrierungsseite
     */
    login: 'Einloggen',
    welcomeBack: 'Willkommen zurück, wir haben dich vermisst!',
    noAccount: 'Noch kein Konto?',
    register: 'Registrieren',
    offline: 'Du scheinst offline zu sein!',
    checkConnection: 'Überprüfe deine Verbindung und versuche es erneut',
    username: 'Benutzername',
    usernameOrEmail: 'Benutzername oder E-Mail',
    usernameRequired: 'Benutzername ist erforderlich ',
    password: 'Passwort',
    passwordErrorLength: 'Muss mindestens 8 Zeichen lang sein',
    forgotPassword: 'Passwort vergessen?',
    byClickingRegister: 'Durch Klicken auf "Registrieren" stimmst du unseren',
    privacyNotice: 'Datenschutzbestimmungen',
    termsAndConditions: 'Nutzungsbedingungen.',
    and: 'und',
    accountRemoved: 'Konto entfernt',
    accountRemovedMessage: 'Dein Konto wurde erfolgreich entfernt.',
    /**
     * Reset-Passwort-Seite
     */
    resetPassword: 'Passwort zurücksetzen',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    emailSent: 'E-Mail erfolgreich gesendet!',
    passwordChanged: 'Passwort geändert',
    passwordUpdated: 'Dein Passwort wurde erfolgreich aktualisiert.',
    incorrectPassword: 'Falsches Passwort',
    passwordDoesNotMatch: 'Passwort stimmt nicht überein. Bitte versuche es erneut.',
    close: 'Schließen',
    emailSentTo: 'E-Mail wurde gesendet an',
    withLinkTo: 'mit einem Link, um dein Passwort zurückzusetzen.',
    reset: 'Zurücksetzen',
    passwordResetEmailSent: 'Wir haben Anweisungen zum Zurücksetzen des Passworts an deine E-Mail-Adresse gesendet',
    passwordResetEmailNotSent: 'Wir konnten keine Anweisungen zum Zurücksetzen des Passworts senden',
    resetPasswordNote: 'Hinweis: Wenn wir das Konto mit der E-Mail-Adresse finden, erhältst du einen Code, um das Zurücksetzen deines Passworts abzuschließen.',
    backTo: 'Zurück zu',
    resetPasswordRules: 'Dein Passwort muss mindestens 8 Zeichen lang sein und eine Kombination aus Buchstaben, Zahlen und Sonderzeichen enthalten.',
    /**
     * Anmelde-Seite
     */
    wallet: 'Wallet',
    walletActivationFail: 'Wallet-Aktivierung fehlgeschlagen.',
    walletActivationFailMessage: 'Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.',
    walletImportSuccess: 'Wallet erfolgreich importiert',
    walletImportSuccessMsg: 'Ihr Wallet wurde erfolgreich importiert.',
    walletNotActivated: 'Wallet nicht aktiviert, bitte erneut versuchen',
    important: 'Wichtig!',
    walletInfo: 'Ihr Wallet wurde aktiviert. Bitte sichern und speichern Sie es an einem sicheren Ort.',
    ok: 'Ok',
    finish: 'Beenden',
    activationSuccessful: 'Aktivierung erfolgreich',
    importCertificate: 'Zertifikat importieren',
    activate: 'Aktivieren',
    reactivate: 'Reaktivieren',
    activateYourWallet: 'Aktivieren Sie Ihr Wallet',
    reactivateYourWallet: 'Reaktivieren Sie Ihr Wallet',
    import: 'Importieren',
    walletImportFail: 'Wallet-Import fehlgeschlagen',
    tryWalletImportAgain: 'Bitte überprüfen Sie die ausgewählte Datei und versuchen Sie es erneut.',
    yourWalletActivated: 'Ihr Wallet wurde erfolgreich aktiviert.',
    youWalletActivatedDescription: 'Bitte halten Sie Ihr Wallet sicher. Teilen Sie es nicht mit anderen, da dies Ihre Blockchain-Identität darstellt. Wir empfehlen Ihnen, Ihr Wallet zu sichern, falls Sie Ihr Gerät verlieren oder wechseln.',
    activateWalletDescription: 'Um auf Ihre Tickets zugreifen zu können, müssen Sie zuerst Ihr Wallet aktivieren. Die Aktivierung Ihres Wallets stellt ein Zertifikat aus, das den Besitz des Tickets nachweist.',
    reactivateWalletDescription: 'Um auf Ihre Tickets zugreifen zu können, müssen Sie zuerst Ihr Wallet reaktivieren. Die Reaktivierung Ihres Wallets stellt ein Zertifikat aus, das den Besitz des Tickets nachweist.',
    beSureToBackUp: 'Sichern Sie Ihr Wallet nach der Aktivierung.',
    beSureToReBackUp: 'Sichern Sie Ihr Wallet nach der Reaktivierung.',
    youAlreadyActivatedWallet: 'Sie haben Ihr Wallet bereits aktiviert. Um auf Ihre Tickets zugreifen zu können, müssen Sie Ihr Zertifikat importieren.',
    importWalletAccessTickets: 'Importieren Sie Ihr Wallet, um auf alle gekauften Tickets zugreifen zu können.',
    almostDoneImportingWallet: 'Sie sind fast fertig! Importieren Ihres Wallets',
    almostDoneActivatingWallet: 'Sie sind fast fertig! Aktivierung Ihres Wallets',
    almostDoneReactivatingWallet: 'Sie sind fast fertig! Reaktivierung Ihres Wallets',
    didNotBackUpWallet: 'Wenn Sie Ihr Zertifikat nicht gesichert haben oder Ihr Telefon verloren haben, kontaktieren Sie den Support unter @BAMSupport.',
    /**
     * Menü
     */
    myProfile: 'Mein Profil',
    save: 'Speichern',
    organizer: 'Organisator',
    signout: 'Abmelden',
    signoutTitle: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    signoutMessage: 'Stellen Sie sicher, dass Sie alle Änderungen gespeichert haben, bevor Sie sich abmelden.',
    applicationSettings: 'Anwendungseinstellungen',
    support: 'Support',
    /**
     * Profil-Seite
     */
    account: 'Konto',
    personalInformation: 'Persönliche Informationen',
    informationUpdated: 'Informationen erfolgreich aktualisiert!',
    invalidEmail: 'Eine gültige E-Mail-Adresse ist erforderlich',
    chooseOption: 'Option auswählen',
    cancel: 'Abbrechen',
    galleryImages: 'Galerie Bilder',
    profilePicture: 'Profilbild',
    imageNotUploaded: 'Bild nicht hochgeladen!',
    useCamera: 'Kamera verwenden',
    removeAccountError: 'Konto konnte nicht entfernt werden, versuche es erneut.',
    removeAccountSure: 'Sind Sie sicher, dass Sie Ihr Konto entfernen möchten?',
    removeAccountInfo: 'Durch das Entfernen Ihres Kontos verlieren Sie alle Tickets, die Sie derzeit besitzen.',
    removeAccount: 'Konto entfernen',
    personalData: 'PERSÖNLICHE DATEN',
    atLeastThreeCharacters: 'Mindestens 3 Zeichen lang',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    dateOfBirthday: 'Geburtsdatum (optional)',
    phone: 'Telefon (optional)',
    address: 'Adresse',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    location: 'ORT',
    paypalAccount: 'Paypal Konto',
    /**
     * Organizer publish page
     */
    transaction: 'Transaktion',
    transactionPublished: 'Transaktion erfolgreich veröffentlicht',
    transactionNotPublished: 'Transaktion konnte nicht veröffentlicht werden',
    transactionProcessing: 'Die Transaktion wird derzeit verarbeitet, bitte warten Sie!',
    /**
     * Register page
     */
    invalidPassword: 'Passwort muss mindestens 8 Zeichen enthalten, einschließlich mindestens eines Kleinbuchstabens, eines Großbuchstabens und einer Zahl.',
    invalidUsername: 'Benutzernamen müssen mindestens 3 Zeichen lang sein und können lateinische Alphabet-Groß- und Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten',
    letsGetOnBoard: 'Lass uns an Bord kommen!',
    enterValidUsername: 'Gültigen Benutzernamen eingeben *',
    enterValidFirstname: 'Gültigen Vornamen eingeben *',
    enterValidLastname: 'Gültigen Nachnamen eingeben ',
    enterValidEmail: 'Gültige E-Mail-Adresse eingeben ',
    alreadyHaveAccount: 'Sie haben bereits ein Konto?',
    /**
     * Tickets overview page
     */
    start: 'Start',
    seating: 'Sitzplatz',
    date: 'Datum',
    edit: 'Bearbeiten',
    ticketInvalidated: 'Dieses Ticket wurde bereits gescannt und verwendet.',
    dateOfSale: 'Verkaufsdatum',
    price: 'Preis',
    expirationDate: 'Verfallsdatum',
    removeFromMarketPlace: 'Vom Marktplatz entfernen',
    activateConfirmTitle: 'Sind Sie sicher, dass Sie dieses Ticket aktivieren möchten?',
    activateConfirmText: 'Wenn aktiviert, können Sie es nicht mehr deaktivieren oder übertragen oder verkaufen.',
    activateTicket: 'Ticket aktivieren',
    ticketIsProcessed: 'Ihr Ticket wird noch bearbeitet - sobald es ausgestellt ist, können Sie es übertragen, verkaufen und aktivieren.',
    moreInfo: 'Weitere Informationen',
    swipeEventDetails: 'Wischen Sie für Eventdetails',
    /**
     * Single Ticket screen
     */
    qrCode: 'QR-Code',
    ticketCantActivate: 'Der QR-Code des Tickets bleibt bis sieben Tage vor der Veranstaltung gesperrt.',
    ticketActivateFirst: 'Um den QR-Code anzuzeigen, muss das Ticket zuerst aktiviert werden.',
    ticketCantActivateEnded: 'Sie können das Ticket nicht aktivieren, nachdem die Veranstaltung stattgefunden hat.',
    showQrCodeAtEntrance: 'Zeigen Sie den QR-Code am Eingang, um Zugang zur Veranstaltung zu erhalten.',
    options: 'Optionen',
    transferTicketsToFriends: 'Übertragen Sie Tickets kostenlos an Ihre Freunde oder verkaufen Sie sie auf unserem sicheren Sekundärmarkt.',
    ticket: 'Ticket',
    discount: 'Rabatt',
    dateAndLocation: 'Datum & Ort',
    ticketHolder: 'Ticketinhaber',
    ticketDetails: 'Ticketdetails',
    readMore: 'Mehr lesen',
    eventDetails: 'Veranstaltungsdetails',
    buyTickets: 'Tickets kaufen',
    detailsAboutTicket: 'Details zum Ticket',
    detailsAboutEvent: 'Details zu dieser Veranstaltung',
    /**
   * Form input component
   */
    gender: 'Geschlecht (Optional)',
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Andere',
    /**
     * Wallet page
     */
    exportShareMessage: 'Sichern Sie Ihre Brieftasche an einem sicheren Ort:',
    backupWallet: 'Brieftasche sichern',
    backup: 'Sichern',
    backupText: 'Sie haben Ihre Brieftasche noch nicht gesichert. Bitte erstellen Sie ein Backup, falls Sie Ihre Brieftasche wiederherstellen müssen.',
    backupIncomplete: 'Backup unvollständig',
    backupComplete: 'Backup abgeschlossen',
    backupSuccessTitle: 'Ihre Brieftasche wurde erfolgreich gesichert.',
    backupSuccessInfo: 'Bitte bewahren Sie Ihre Brieftasche sicher auf. Teilen Sie sie nicht mit anderen, da dies Ihre Blockchain-Identität darstellt. ',
    permissionDenied: 'Zugriff verweigert. Bitte versuchen Sie es erneut.',
    shareMessage: 'Lassen Sie uns einige Tickets teilen! Hier ist meine ',
    copied: 'Kopiert',
    add: 'Hinzufügen',
    connectedWallets: 'Verbundene Brieftaschen',
    connectYourWallet: 'Verbinden Sie Ihre Brieftasche',
    connectYourWalletInfo: 'Wenn Sie noch keine Brieftasche haben, können Sie einen Anbieter auswählen, die App herunterladen und jetzt eine erstellen.',
    metamask: 'Metamask',
    to: 'zu',
    the: 'die',
    downloads: 'Downloads',
    folder: 'Ordner',
    /**
     * Offline page
     */
    offlineHeader: 'Offline',
    offlineText: 'Sie sind momentan offline.',
    offlineSecondText: 'Bestimmte Funktionen sind möglicherweise nicht verfügbar.',
    /**
     * Home page
     */
    tickets: 'Tickets',
    pastExperience: 'Vergangene Erlebnisse',
    upcoming: 'Bevorstehende',
    noTickets: 'Sie haben noch keine Tickets.',
    checkOutOur: 'Schauen Sie sich unseren ',
    ticketMarketplace: 'Ticket-Marktplatz',
    toGetThem: ' an, um welche zu bekommen.',
    /**
     * Transfer page
     */
    transferTicket: 'Tickets übertragen',
    transferTicketDescription: 'Scannen Sie einen QR-Code oder geben Sie die Empfänger-Wallet-ID ein, um Tickets auszuwählen und zu übertragen.',
    bamWalletShareTitleStart: 'Ihr Freund hat die ',
    bamWalletShareTitleEnd: '-App noch nicht? ',
    bamWalletShareSubTitleStart: 'Laden Sie Ihre Freunde ein und teilen Sie die ',
    bamWalletShareSubTitleEnd: ', um einen einfachen Tickettransfer zu gewährleisten.',
    enterWalletId: 'Empfänger-Wallet-ID',
    walletIdError: 'Benutzer nicht gefunden / unvollständige ID',
    share: 'Teilen',
    transfer: 'Übertragen',
    sell: 'Verkaufen',
    sellTicket: 'Ticket verkaufen',
    walletId: 'Wallet-ID',
    transferModalSbtitle: 'Nach der Übertragung werden die Tickets aus Ihrer Wallet entfernt.',
    shareModalTitleStart: 'Teile ',
    shareModalTitleEnd: ' mit einem Freund',
    succesTransferMessageTile: 'Ticket(s) übertragen',
    errorTransferMessageTile: 'Ticket(s) Übertragung fehlgeschlagen',
    succesTransferMessage: 'Ihr(e) Ticket(s) wurde(n) erfolgreich übertragen. Sie sind nicht mehr in Ihrer Wallet verfügbar.',
    errorTransferMessage: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
    done: 'Fertig',
    areYouSureTransfer: 'Möchten Sie wirklich übertragen',
    ticketsTo: 'Ticket(s) an',
    tryAgain: 'Erneut versuchen',
    findUser: 'Benutzer finden',
    emailOrWalletId: 'E-Mail oder Wallet-ID',
    emailDoesNotExist: 'Wir können keinen Benutzer mit dieser E-Mail finden. Überprüfen Sie die E-Mail oder drücken Sie "Einladen", um den Benutzer einzuladen und Tickets zu übertragen.',
    invite: 'Einladen',
    selectTicketsToTransfer: 'Wählen Sie Tickets aus, die übertragen werden sollen: ',
    transferring: 'Übertrage ',
    transferringTickets: ' Ticket(s).',
    okay: 'Okay',
    sureCancelTransferTo: 'Sind Sie sicher, dass Sie die Übertragung annullieren möchten an ',
    ifYouCancelNowRepeatLater: 'Wenn Sie den Übertragungsvorgang jetzt abbrechen, können Sie ihn später wiederholen.',
    cancelTransfer: 'Übertragung abbrechen',
    backToTickets: 'Zurück zu den Tickets',
    successSentInvite: 'Sie haben erfolgreich eine Einladung an einen Benutzer gesendet.',
    ableToTransferTicketsNow: 'Sie können jetzt Ticket(s) an den Benutzer übertragen.',
    /**
     * Qrcode Scanner
     */
    qrcodeScannerScreenTitle: 'Wallet scannen',
    scanWallet: 'Wallet scannen',
    /**
     * Ticketinhaberinformationen
     */
    cancelSureTitle: 'Möchten Sie wirklich abbrechen?',
    cancelSureText: 'Stellen Sie sicher, dass Sie alle Änderungen gespeichert haben, bevor Sie den Vorgang abbrechen.',
    confirm: 'Bestätigen',
    /**
     * Ticket verkaufen
     */
    sellTickets: 'Tickets verkaufen',
    setExpiration: 'Ablaufdatum setzen',
    ticketPrice: 'Ticketpreis',
    sellTicketConfirmTitle: 'Sind Sie sicher, dass Sie Ihr Ticket auf dem Sekundärmarkt verkaufen möchten?',
    sellTicketConfirmMessage: 'Sie werden auf Ihre(n) Ticket(s) in Ihrer Wallet zugreifen und den Verkauf stornieren können.',
    succesSellTile: 'Ticket(s) auf dem Marktplatz veröffentlicht',
    succesSellMessage: 'Ihr(e) Ticket(s) wurde(n) erfolgreich auf dem Sekundärmarkt veröffentlicht.',
    errorSellTitle: 'Fehler beim Verkaufen des Tickets',
    errorSellMessage: 'Beim Veröffentlichen Ihres Tickets ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal. ',
    sellFeeHintStart: 'Der Veranstalter nimmt eine Gebühr von',
    sellFeeHintMiddle: '% auf den Verkauf für diese Veranstaltung. Sie erhalten',
    sellNoFeeHint: 'Der Veranstalter nimmt für den Verkauf dieser Veranstaltung keine Gebühr. Sie erhalten',
    setExpirationDate: 'Ablaufdatum festlegen',
    payout: 'Auszahlung',
    payoutHintText1: 'Bitte geben Sie ein PayPal-Konto oder eine E-Mail-Adresse an, die für die Auszahlung verwendet werden soll.',
    payoutHintText2: 'Zahlungen erfolgen automatisch über PayPal, sobald Ihr Ticket verkauft ist. Sie erhalten eine E-Mail-Benachrichtigung, nachdem der Verkauf abgeschlossen ist.',
    payoutHintText3: 'Vielen Dank, dass Sie unsere Plattform nutzen! Wenn Sie Fragen haben, wenden Sie sich an unser Support-Team.',
    publishingTicketToSecondaryMarket: 'Veröffentlichung Ihres Tickets auf dem Sekundärmarkt.',
    /**
   * Bottom menu
   */
    nft: 'nft',
    profile: 'Profil',
    /**
     * NFT screen
     */
    myCollection: 'Meine Sammlung',
    noNFTsYet: 'Noch keine NFTs vorhanden',
    doNotSeeNFT: 'Sie sehen Ihren NFT nicht?',
    importNFTs: 'NFTs importieren',
    description: 'Beschreibung',
    chain: 'Chain',
    /**
     * Metamask wallets screen
     */
    selectWallet: 'Wallet auswählen',
    connectedAddresses: 'Verbundene Adressen',
    confirmRemoveWalletTitle: 'Möchten Sie diese Adresse wirklich entfernen?',
    confirmRemoveWalletText: 'Wenn Sie diese Adresse entfernen, werden alle verbundenen NFTs entfernt.',
    removeAddress: 'Adresse entfernen',
    /**
     * Metamask add component
     */
    metamaskWalletConnectSuccessTitle: 'Metamask-Wallet verbunden.',
    metamaskWalletConnectSuccessText: 'Ihr Metamask-Wallet wurde erfolgreich hinzugefügt.',
    metamaskWalletConnectErrorTitle: 'Metamask-Wallet-Fehler.',
    metamaskWalletConnectErrorText: 'Wallet konnte nicht aus Metamask hinzugefügt werden.',
    /**
     * App screen
     */
    applicationUpdateTitle: 'Aktualisierung der Anwendung erforderlich.',
    applicationUpdateText: 'Eine neue Version der Anwendung ist verfügbar und erforderlich, um fortzufahren. Bitte klicken Sie unten, um auf die neueste Version zu aktualisieren.',
    update: 'Aktualisieren',
    understand: 'Ich verstehe',
    /**
     * Settings
     */
    settings: 'Einstellungen',
    notifications: 'Benachrichtigungen',
    enableNotifications: 'Benachrichtigungen aktivieren',
    eventStart: 'Eventstart',
    checkIn: 'Einchecken',
    none: 'Keine',
    minutes: 'Minuten',
    hour: 'Stunde',
    fiveMinutesBefore: '5 Minuten vorher',
    tenMinutesBefore: '10 Minuten vorher',
    fifteenMinutesBefore: '15 Minuten vorher',
    thirtyMinutesBefore: '30 Minuten vorher',
    fourtyFiveMinutesBefore: '45 Minuten vorher',
    oneHourBefore: '1 Stunde vorher',
    fiveMinutes: '5 Minuten',
    tenMinutes: '10 Minuten',
    fifteenMinutes: '15 Minuten',
    thirtyMinutes: '30 Minuten',
    fourtyFiveMinutes: '45 Minuten',
    oneHour: '1 Stunde',
    language: 'Sprache',
    bs: 'Bosnisch',
    de: 'Deutsch',
    en: 'Englisch',
    es: 'Spanisch',
    fr: 'Französisch',
    sr: 'Serbisch',
    this: 'Dies',
    is: 'ist',
    near: 'in der Nähe',
    /**
     * Notifications
     */
    today: 'Heute',
    clear: 'Löschen',
    noNewNotifications: 'Keine neuen Benachrichtigungen',
    noNewNotificationsHint: "Du bist auf dem neuesten Stand!",
    /**
     * Validator App
     */
    /**
     * Login screen
     */
    welcome: 'Welcome',
    scanQrCodeHint: 'Use the QR code shown in your organizer dashboard to login.',
    scanQrCode: 'Scan QR code',
    switchedEnvironment: 'Switched Environment',
    switchedEnvironmentToProd: 'Switched environment to prod',
    switchedEnvironmentToDev: 'Switched environment to dev',
    appVersion: 'App Version',
    /**
     * Login-Scan screen
     */
    qrCodeScannerHint: 'Please scan the organizer QR code to login.',
    loginQrErrorTitle: 'Login failed.',
    loginQrError: 'Please use the correct organiser QR code from the admin dashboard.',
    loginLoading: "Almost done. Please don't exit the application until information is loaded.",
    /**
     * Ticket-Scan screen
     */
    tapToStartScanning: 'Tap to start scanning',
    validTicket: 'Check-In successful!',
    invalidTicket: 'Invalid Ticket!',
    scannedAt: 'Scanned at',
    venueInfoError: 'Unable to fetch venue information',
    signingKeyError: 'Unable to fetch signing key',
    eventInfoError: 'Unable to fetch event information',
    ticketQrError: 'Unable to scan QR-Code',
    scanTickets: 'Scan Tickets',
    ticketCountError: 'Unable to fetch amount of scanned tickets',
    scanAgain: 'Scan again',
    signOutTitle: 'Are you sure you want to Sign Out?',
    signOutText: 'Make sure you saved all the changes you made before signing out.',
    logout: 'Logout',
    checkedIn: 'Checked-in:',
    of: 'of',
    validatingTicket: 'Validating ticket.',
};
//# sourceMappingURL=de.js.map